import { render } from "./BaseModal.vue?vue&type=template&id=1902a95e&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=1902a95e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1902a95e"

export default script